import type { FC } from 'react'

/** 無効な slug / 口コミ機能が無効な企業のときに表示するページ */
export const ReviewNotFound: FC = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted px-4">
      <div className="text-center">
        <p className="text-lg font-medium text-foreground">ページが見つかりません</p>
        <p className="mt-2 text-sm text-muted-foreground">
          URLが正しくないか、現在この口コミフォームはご利用いただけません。
        </p>
      </div>
    </div>
  )
}
